import React, { useState, useEffect } from 'react';
import CatGuardian from './CatGuardian';
import {getCompletedCards} from "../../api";

const HeaderGuardian = () => {
    const [hasCompletedTask, setHasCompletedTask] = useState(false);
    const [showStatus, setShowStatus] = useState(false); // 메시지 표시 여부

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const response = await getCompletedCards(0, 1);
                const list = response.data._embedded?.getList || [];
                setHasCompletedTask(list.length > 0);
            } catch (e) {
                // 에러 시 무시
            }
        };

        checkStatus();
        // const timer = setInterval(checkStatus, 15000);
        window.addEventListener('cardStatusChanged', checkStatus);
        return () => {
            // clearInterval(timer);
            window.removeEventListener('cardStatusChanged', checkStatus);
        }
    }, []);

    // 클릭 시 메시지를 띄우고 2초 뒤에 숨김
    const handleClick = () => {
        setShowStatus(true);
        setTimeout(() => {
            setShowStatus(false);
        }, 2000);
    };

    return (
        <div
            onClick={handleClick}
            style={{
                position: 'relative', // 말풍선 위치 기준
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
            }}
        >
            {/* 고양이 캐릭터 */}
            <CatGuardian isWorking={hasCompletedTask} />

            {/* 상태 메시지 말풍선 */}
            {showStatus && (
                <div style={{
                    position: 'absolute',
                    top: '65px', // 헤더 아래쪽에 표시
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                }}>
                    {hasCompletedTask ? '🍦 녹는 중...' : '😴 쉬는 중...'}

                    {/* 말풍선 꼬리 (역삼각형) */}
                    <div style={{
                        position: 'absolute',
                        top: '-5px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent',
                        borderBottom: '5px solid rgba(0, 0, 0, 0.8)'
                    }} />
                </div>
            )}
        </div>
    );
};

export default HeaderGuardian;